import React from 'react'
import { useMediaQuery, LazyImage } from '@offerzen/pinata-shame'

import Container from '../Container'
import MobileNavMenu from '../MobileNavMenu'
import NavMenu from '../NavMenu'
import NavVisibilityBadge from '../NavVisibilityBadge'
import MobileNavVisibilityBadge from '../MobileNavVisibilityBadge'

import styles from './styles'

/**
 * @typedef {Object} Metadata
 * @property {string} [currentState]
 * @property {boolean} [availabilitySet]
 * @property {boolean} [disabled]
 * @property {number} [unreadIrMessages]
 * @property {string} [emailPreferencesAccessTokenKey]
 */

/**
 * Navbar component
 *
 * @param {Object} props
 * @param {Function} [props.trackVisibilityStatus]
 * @param {() => void} [props.signOut]
 * @param {Metadata} [props.metadata]
 * @param {string} [props.candidateSlug]
 *
 * @returns {JSX.Element}
 */
const Navbar = ({ metadata, trackVisibilityStatus, signOut }) => {
  const { isPhoneOrLarger, isDesktopOrLarger } = useMediaQuery()

  return (
    <nav className={styles.wrapper}>
      <Container className={styles.container}>
        <a href="/" className={styles.logo}>
          <LazyImage className={styles.logoImage} loader={() => import('../../../assets/offerzen-logo.svg')} />
        </a>

        <div className={styles.navItems}>
          <Choose>
            <When condition={isDesktopOrLarger}>
              <If condition={metadata.currentState}>
                <NavVisibilityBadge
                  currentState={metadata.currentState}
                  trackVisibilityStatus={action => trackVisibilityStatus(action, 'desktop')}
                />
              </If>

              <NavMenu
                candidateState={metadata.currentState}
                disabledCandidate={metadata.disabled}
                unreadInterviewRequestCount={metadata.unreadIrMessages}
                signOut={signOut}
                emailPreferencesAccessTokenKey={metadata.emailPreferencesAccessTokenKey}
              />
            </When>

            <Otherwise>
              <If condition={metadata.currentState}>
                <MobileNavVisibilityBadge
                  currentState={metadata.currentState}
                  trackVisibilityStatus={action => trackVisibilityStatus(action, isPhoneOrLarger ? 'tablet' : 'mobile')}
                />
              </If>

              <MobileNavMenu
                candidateState={metadata.currentState}
                candidateAvailabilitySet={metadata.availabilitySet}
                disabledCandidate={metadata.disabled}
                unreadInterviewRequestCount={metadata.unreadIrMessages}
                signOut={signOut}
                emailPreferencesAccessTokenKey={metadata.emailPreferencesAccessTokenKey}
              />
            </Otherwise>
          </Choose>
        </div>
      </Container>
    </nav>
  )
}

export default Navbar
